import React from 'react';
import CloseIcon from '../../assets/images/close.svg';
import { dark_close } from '../../assets/images';

const UndoModal = ({ title, description, visible, imgsrc, action, height, width }) => {
  const undoIcon = <img src={imgsrc} alt='undo_icon' className='h-14 w-14 inline-block mt-3' />;
  const closeIcon = <img src={CloseIcon} alt='close_icon' className='inline-block' />;

  return (
    <div
    className={`fixed z-20 inset-0 overflow-y-auto ${visible ? '' : 'hidden'}`}
    aria-labelledby='modal-title'  
    aria-modal='true'
  >
    <div className='flex items-end justify-center  text-center sm:block sm:p-0'>
      <div
        className='fixed inset-0 opacity-50 transition-opacity'
        aria-hidden='true'
        style={{backgroundColor : '#000000'}}
        onClick={() => action('no')}
      >
      </div>
      <span className='sm:inline-block sm:align-middle sm:h-screen' aria-hidden='true'>
        &#8203;
      </span>  
      <div className="inline-block  align-bottom bg-white text-left overflow-hidden shadow-xl transform transition-75 sm:my-8 sm:align-middle  sm:w-full"
      style={{zIndex : 1000, borderRadius : '10px', height : height , width : width}}
      >
        <div className="bg-white px-4 sm:p-6">
          <div className='flex flex-row-reverse '>
            <img src={dark_close} alt='closeIcon' className='cursor-pointer' onClick={() => action('no')} />
          </div>
            <div className='justify-center text-center mt-0 '>
              {undoIcon}
              <p className='text-xl text-gray-700 font-semibold mb-0 mt-6 leading-none'>{title}</p>
              <p className='text-gray-600 text-base mt-5 mb-0 leading-none'>{description}</p>
              <div className='flex mt-8 justify-center'>
                <button
                  className='text-base bg-white font-semibold text-blue-600 px-6 py-2.5 mr-6 rounded-md focus:outline-none'
                  style={{ border: '1px solid #C7CDE0' }}
                  onClick={() => action('no')}
                >
                No
                </button>
                <button
                  className='text-base bg-blue-500 font-semibold text-white px-6 py-2.5 rounded-md focus:outline-none'
                  onClick={() => action('yes')}
                >
                  Yes
                </button>
               </div>
            </div>  
        </div>
      </div>
    </div>
  </div> 
  );
};

export default UndoModal;
